// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".sale-area-container[data-v-3973db3d] {\n  display: flex;\n  align-items: top;\n}\n.sale-area-container .sale-area-item[data-v-3973db3d] {\n  flex: 1;\n  position: relative;\n  top: 10px;\n}\n.sale-area-container .del-btn[data-v-3973db3d] {\n  width: 50px;\n  color: red;\n}\n", ""]);
// Exports
module.exports = exports;
